import React, { useCallback, useMemo, useState } from "react";
import "./index.scss";
import { MspAccountsTableRow } from "./msp-accounts-table-row";
import { MspAccountsTableHeader } from "./msp-accounts-table-header";
import styles from "./index.module.scss";
import ArrowIcon from "../../../icons/arrow.icon";
import { Dropdown, Form } from "react-bootstrap";
import { RowDropdown } from "./row-dropdown";
import rowStyles from "./msp-accounts-table-row.module.scss";
import { TagsDropdown } from "./components/tags-dropdown";
import { DistributorDropdown } from "./components/distributor-dropdown";

const rowDataList = [
  {
    id: "1",
    companyName: "M3Networks ltd.",
    companyAvatar: null,
    country: "United Kingdom",
    primaryContact: {
      initial: "M",
      name: "Mark Lamb",
      email: "mark.lamb@m3networks.co.uk",
      bgColor: "bg-additional-violet-50",
    },
    accountManager: {
      initial: "R",
      name: "Robin Smit",
      email: "robinsmit@portland.com",
      bgColor: "bg-support-alert-50",
    },
    createdDate: "12/01/24",
    lastActivity: "12/01/24 17:00 UTC",
    subscriptionStatus: {
      label: "Paid Plan 1",
      bgColor: "bg-support-success-0",
      textColor: "text-support-success-80",
    },
    trialDays: "14 Days",
    renewalDate: "Renews 05/05/26",
    autoRenew: "Yes",
    paymentMethod: "No",
    tags: [
      {
        label: "High Priority",
        bgColor: "bg-support-alert-0",
        textColor: "text-support-alert-50",
      },
      {
        label: "Referral",
        bgColor: "bg-brand-purple-0",
        textColor: "text-brand-purple-50",
      },
    ],
    dealStatus: {
      label: "Won",
      icon: "/images/msp/green-tick-circle.svg",
      borderColor: "border-support-success-80",
      textColor: "text-support-success-80",
    },
    users: "5",
    licenses: "5",
    devices: "95",
    tickets: "13",
    integrations: [
      { icon: "/image.png", name: "NinjaRMM" },
      { icon: "/avatar-2.png", name: "ConnectWise Manage" },
    ],
    mrr: "435",
    arr: "10",
    nps: "3",
  },
  {
    id: "2",
    companyName: "ABC",
    companyAvatar: null,
    country: "United Kingdom",
    primaryContact: {
      initial: "A",
      name: "Mark Lamb",
      email: "mark.lamb@m3networks.co.uk",
      bgColor: "bg-additional-violet-50",
    },
    accountManager: {
      initial: "R",
      name: "Robin Smit",
      email: "robinsmit@portland.com",
      bgColor: "bg-support-alert-50",
    },
    createdDate: "12/01/24",
    lastActivity: "12/01/24 17:00 UTC",
    subscriptionStatus: {
      label: "Paid Plan 1",
      bgColor: "bg-support-success-0",
      textColor: "text-support-success-80",
    },
    trialDays: "14 Days",
    renewalDate: "Renews 05/05/26",
    autoRenew: "Yes",
    paymentMethod: "No",
    tags: [],
    dealStatus: null,
    users: "5",
    licenses: "5",
    devices: "95",
    tickets: "13",
    integrations: [
      { icon: "/image.png", name: "NinjaRMM" },
      { icon: "/avatar-2.png", name: "ConnectWise Manage" },
    ],
    mrr: "435",
    arr: "10",
    nps: "3",
  },
  {
    id: "3",
    companyName: "Marvel",
    companyAvatar: null,
    country: "United Kingdom",
    primaryContact: {
      initial: "M",
      name: "Mark Lamb",
      email: "mark.lamb@m3networks.co.uk",
      bgColor: "bg-additional-violet-50",
    },
    accountManager: {
      initial: "R",
      name: "Robin Smit",
      email: "robinsmit@portland.com",
      bgColor: "bg-support-alert-50",
    },
    createdDate: "12/01/24",
    lastActivity: "12/01/24 17:00 UTC",
    subscriptionStatus: {
      label: "Paid Plan 1",
      bgColor: "bg-support-success-0",
      textColor: "text-support-success-80",
    },
    trialDays: "14 Days",
    renewalDate: "Renews 05/05/26",
    autoRenew: "Yes",
    paymentMethod: "No",
    tags: [],
    dealStatus: null,
    users: "5",
    licenses: "5",
    devices: "95",
    tickets: "13",
    integrations: [
      { icon: "/image.png", name: "NinjaRMM" },
      { icon: "/avatar-2.png", name: "ConnectWise Manage" },
    ],
    mrr: "435",
    arr: "10",
    nps: "3",
  },
  {
    id: "4",
    companyName: "Honey Ltd",
    companyAvatar: null,
    country: "United Kingdom",
    primaryContact: {
      initial: "H",
      name: "Mark Lamb",
      email: "mark.lamb@m3networks.co.uk",
      bgColor: "bg-additional-violet-50",
    },
    accountManager: {
      initial: "R",
      name: "Robin Smit",
      email: "robinsmit@portland.com",
      bgColor: "bg-support-alert-50",
    },
    createdDate: "12/01/24",
    lastActivity: "12/01/24 17:00 UTC",
    subscriptionStatus: {
      label: "Paid Plan 1",
      bgColor: "bg-support-success-0",
      textColor: "text-support-success-80",
    },
    trialDays: "14 Days",
    renewalDate: "Renews 05/05/26",
    autoRenew: "Yes",
    paymentMethod: "No",
    tags: [],
    dealStatus: null,
    users: "5",
    licenses: "5",
    devices: "95",
    tickets: "13",
    integrations: [
      { icon: "/image.png", name: "NinjaRMM" },
      { icon: "/avatar-2.png", name: "ConnectWise Manage" },
    ],
    mrr: "435",
    arr: "10",
    nps: "3",
  },
  {
    id: "5",
    companyName: "Master Class",
    companyAvatar: null,
    country: "United Kingdom",
    primaryContact: {
      initial: "M",
      name: "Mark Lamb",
      email: "mark.lamb@m3networks.co.uk",
      bgColor: "bg-additional-violet-50",
    },
    accountManager: {
      initial: "R",
      name: "Robin Smit",
      email: "robinsmit@portland.com",
      bgColor: "bg-support-alert-50",
    },
    createdDate: "12/01/24",
    lastActivity: "12/01/24 17:00 UTC",
    subscriptionStatus: {
      label: "Paid Plan 1",
      bgColor: "bg-support-success-0",
      textColor: "text-support-success-80",
    },
    trialDays: "14 Days",
    renewalDate: "Renews 05/05/26",
    autoRenew: "Yes",
    paymentMethod: "No",
    tags: [],
    dealStatus: null,
    users: "5",
    licenses: "5",
    devices: "95",
    tickets: "13",
    integrations: [
      { icon: "/image.png", name: "NinjaRMM" },
      { icon: "/avatar-2.png", name: "ConnectWise Manage" },
    ],
    mrr: "435",
    arr: "10",
    nps: "3",
  },
  {
    id: "6",
    companyName: "Domino's Pizza",
    companyAvatar: null,
    country: "United Kingdom",
    primaryContact: {
      initial: "D",
      name: "Mark Lamb",
      email: "mark.lamb@m3networks.co.uk",
      bgColor: "bg-additional-violet-50",
    },
    accountManager: {
      initial: "R",
      name: "Robin Smit",
      email: "robinsmit@portland.com",
      bgColor: "bg-support-alert-50",
    },
    createdDate: "12/01/24",
    lastActivity: "12/01/24 17:00 UTC",
    subscriptionStatus: {
      label: "Paid Plan 1",
      bgColor: "bg-support-success-0",
      textColor: "text-support-success-80",
    },
    trialDays: "14 Days",
    renewalDate: "Renews 05/05/26",
    autoRenew: "Yes",
    paymentMethod: "No",
    tags: [],
    dealStatus: null,
    users: "5",
    licenses: "5",
    devices: "95",
    tickets: "13",
    integrations: [
      { icon: "/image.png", name: "NinjaRMM" },
      { icon: "/avatar-2.png", name: "ConnectWise Manage" },
    ],
    mrr: "435",
    arr: "10",
    nps: "3",
  },
];

const v2HeaderColumns = [
  { label: "Company name", hasArrow: true },
  { label: "Location" },
  { label: "Distributor" },
  { label: "Account Owner" },
  { label: "Sales Rep" },
  { label: "Signed up" },
  { label: "Last Seen" },
  { label: "Subscription" },
  { label: "Renewal Date" },
  { label: "Auto Renewal" },
  { label: "Tags" },
  { label: "Status" },
  { label: "Members" },
  { label: "Companies" },
  { label: "Clients" },
  { label: "Prospects" },
  { label: "Integrations" },
  { label: "Products" },
  { label: "Services" },
  { label: "Packages" },
  { label: "" },
];

const mapRowDataForV2 = (row) => ({
  company: {
    name: row.companyName ?? "",
    avatar: row.companyAvatar,
  },
  location: row.country ?? "",
  distributor: row.distributor ?? "Portland",
  primaryContact: row.primaryContact ?? {},
  secondaryContact: row.accountManager ?? {},
  createdDate: row.createdDate ?? "",
  lastActivity: row.lastActivity ?? "",
  subscription: {
    status: row.subscriptionStatus?.label ?? "",
  },
  renewalDate: row.renewalDate ?? "",
  autoRenewal: row.autoRenew ?? row.autoRenewal ?? "",
  tags: row.tags ?? [],
  dealStatus: row.dealStatus,
  metrics: {
    members: row.users,
    companies: row.licenses,
    clients: row.devices,
    prospects: row.tickets,
  },
  integrations: row.integrations ?? [],
  additionalMetrics: {
    products: row.mrr,
    services: row.arr,
    packages: row.nps,
  },
});

export const MspAccountsTable = ({
  isArchived = false,
  onSelectionChange,
  forceShowCheckboxes = false,
  variant = "v1",
  isDistributor = false,
  isDistributorView = false,
  onRowClick,
}) => {
  const wrapperRef = React.useRef(null);
  const borderRef = React.useRef(null);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [lastSelectedIndex, setLastSelectedIndex] = useState(null);
  const v2Rows = useMemo(() => rowDataList.map(mapRowDataForV2), []);

  const handleRowSelect = useCallback((index, isSelected, isShiftClick = false) => {
    setSelectedRows((prev) => {
      const newSelection = new Set(prev);
      let shouldShowCheckboxes = false;
      
      if (isShiftClick && lastSelectedIndex !== null) {
        const start = Math.min(lastSelectedIndex, index);
        const end = Math.max(lastSelectedIndex, index);
        for (let i = start; i <= end; i++) {
          newSelection.add(i);
        }
        // When shift+click selects 2+ items, checkboxes should appear
        shouldShowCheckboxes = newSelection.size >= 2;
      } else {
        if (isSelected) {
          newSelection.add(index);
        } else {
          newSelection.delete(index);
        }
      }
      
      if (onSelectionChange) {
        onSelectionChange(Array.from(newSelection).map(i => rowDataList[i]));
      }
      
      // If shift+click selected 2+ items, notify parent to show checkboxes
      if (shouldShowCheckboxes && onSelectionChange) {
        // The parent component should handle showing checkboxes based on selection size
        // This is already handled by the showCheckbox calculation below
      }
      
      return newSelection;
    });
    
    if (!isShiftClick) {
      setLastSelectedIndex(index);
    }
  }, [lastSelectedIndex, onSelectionChange]);

  const handleSelectAll = useCallback((isSelected) => {
    if (isSelected) {
      const allIndices = new Set(rowDataList.map((_, index) => index));
      setSelectedRows(allIndices);
      if (onSelectionChange) {
        onSelectionChange(rowDataList);
      }
    } else {
      setSelectedRows(new Set());
      if (onSelectionChange) {
        onSelectionChange([]);
      }
    }
  }, [onSelectionChange]);

  const showCheckbox = (forceShowCheckboxes || selectedRows.size >= 2) && !isDistributor;

  const prevForceShowCheckboxes = React.useRef(forceShowCheckboxes);
  React.useEffect(() => {
    if (prevForceShowCheckboxes.current === true && forceShowCheckboxes === false) {
      setSelectedRows(new Set());
      setLastSelectedIndex(null);
      if (onSelectionChange) {
        onSelectionChange([]);
      }
    }
    prevForceShowCheckboxes.current = forceShowCheckboxes;
  }, [forceShowCheckboxes, onSelectionChange]);

  React.useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const borderEl = borderRef.current;

    const updateBorderPosition = () => {
      if (!borderEl) return;
      const rect = wrapper.getBoundingClientRect();
      const checkboxOffset = showCheckbox ? 40 + 8 : 0;
      const borderLeft = rect.left + 205 + checkboxOffset;
      borderEl.style.left = `${borderLeft}px`;
      borderEl.style.top = `${rect.top}px`;
      borderEl.style.height = `${rect.height}px`;
    };

    const handleWheel = (e) => {
      if (e.shiftKey || Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        wrapper.scrollLeft += e.deltaX || e.deltaY;
        return;
      }
      
      if (wrapper.scrollWidth > wrapper.clientWidth) {
        e.preventDefault();
        wrapper.scrollLeft += e.deltaY;
      }
    };

    wrapper.addEventListener("wheel", handleWheel, { passive: false });

    if (borderEl) {
    wrapper.addEventListener("scroll", updateBorderPosition);
    window.addEventListener("resize", updateBorderPosition);
    window.addEventListener("scroll", updateBorderPosition, true);
    updateBorderPosition();
    }

    return () => {
      wrapper.removeEventListener("wheel", handleWheel);
      if (borderEl) {
      wrapper.removeEventListener("scroll", updateBorderPosition);
      window.removeEventListener("resize", updateBorderPosition);
      window.removeEventListener("scroll", updateBorderPosition, true);
      }
    };
  }, [showCheckbox, variant, isDistributor]);

  const isAllSelected = selectedRows.size > 0 && selectedRows.size === rowDataList.length;
  const isIndeterminate = selectedRows.size > 0 && selectedRows.size < rowDataList.length;

  if (variant === "v2") {
    return (
      <div ref={wrapperRef} className={styles.tableWrapper}>
        <div ref={borderRef} className={styles.firstColumnBorder}></div>
        <div className={styles.v2Wrapper}>
          <div className={styles.v2Table}>
            <V2NavigationSection 
              isDistributor={isDistributor}
              showCheckbox={showCheckbox}
              isAllSelected={isAllSelected}
              isIndeterminate={isIndeterminate}
              onSelectAll={handleSelectAll}
            />
            {v2Rows.map((row, index) => (
              <V2DataRow 
                key={`${row.company.name}-${index}`} 
                data={row} 
                isDistributorView={isDistributorView}
                onRowClick={onRowClick}
                rowIndex={index}
                originalRowData={rowDataList[index]}
                isDistributor={isDistributor}
                showCheckbox={showCheckbox}
                isSelected={selectedRows.has(index)}
                onSelect={(isSelected, isShiftClick) => handleRowSelect(index, isSelected, isShiftClick)}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div ref={wrapperRef} className={styles.tableWrapper}>
      <div ref={borderRef} className={styles.firstColumnBorder}></div>
      <div className={styles.table}>
        <MspAccountsTableHeader 
          isAllSelected={isAllSelected}
          isIndeterminate={isIndeterminate}
          onSelectAll={handleSelectAll}
          showCheckbox={showCheckbox}
        />
        {rowDataList.map((rowData, index) => (
          <MspAccountsTableRow 
            key={index} 
            rowData={rowData} 
            isArchived={isArchived}
            isSelected={selectedRows.has(index)}
            onSelect={(isSelected, isShiftClick) => handleRowSelect(index, isSelected, isShiftClick)}
            showCheckbox={showCheckbox}
            isDistributorView={isDistributorView}
            onRowClick={onRowClick}
            rowIndex={index}
          />
        ))}
      </div>
    </div>
  );
};

const getContactAvatarClass = (bgColor) => {
  if (bgColor === "bg-support-alert-50") {
    return styles.contactAvatarAlert;
  }
  return styles.contactAvatarViolet;
};

const getStatusClass = (dealStatus) => {
  if ((dealStatus?.textColor || "").includes("success")) {
    return styles.statusSuccess;
  }
  return "";
};

const V2NavigationSection = ({ isDistributor = false, showCheckbox = false, isAllSelected = false, isIndeterminate = false, onSelectAll }) => {
  const filteredColumns = isDistributor 
    ? v2HeaderColumns.filter(column => column.label !== "Distributor")
    : v2HeaderColumns;
  
  let gridTemplate = isDistributor 
    ? "205px 160px 234px 244px 160px 160px 140px 146px 121px 167px 96px 88px 88px 88px 88px 213px 96px 96px 88px 40px"
    : "205px 160px 163px 234px 244px 160px 160px 140px 146px 121px 167px 96px 88px 88px 88px 88px 213px 96px 96px 88px 40px";
  
  if (showCheckbox) {
    gridTemplate = `40px ${gridTemplate}`;
  }
  
  return (
    <header className={styles.v2Header} style={{ gridTemplateColumns: gridTemplate }}>
      {showCheckbox && (
        <div className={styles.v2CheckboxHeaderCell}>
          <div className={styles.checkboxContainer}>
            <Form.Group className={styles.checkboxGroup}>
              <Form.Check
                type="checkbox"
                checked={isAllSelected}
                ref={(input) => {
                  if (input) input.indeterminate = isIndeterminate;
                }}
                onChange={(e) => onSelectAll && onSelectAll(e.target.checked)}
                className={styles.checkbox}
              />
            </Form.Group>
          </div>
        </div>
      )}
      {filteredColumns.map((column, index) => (
        <div
          key={`${column.label || "actions"}-${index}`}
          className={`${styles.v2HeaderCell} ${index === 0 ? styles.v2FirstColHeader : ""}`}
          style={index === 0 && showCheckbox ? { left: 'calc(40px + 0.5rem)' } : undefined}
        >
          {column.label ? (
            <>
              <span className={styles.v2HeaderLabel}>{column.label}</span>
              {column.hasArrow && <ArrowIcon className={styles.v2Arrow} fill="#616778" />}
            </>
          ) : null}
        </div>
      ))}
    </header>
  );
};

const V2DataRow = ({ data, isDistributorView = false, onRowClick, rowIndex, originalRowData, isDistributor = false, showCheckbox = false, isSelected = false, onSelect }) => {
  const {
    company,
    location,
    distributor,
    primaryContact,
    secondaryContact,
    createdDate,
    lastActivity,
    subscription,
    renewalDate,
    autoRenewal,
    tags,
    dealStatus,
    metrics = {},
    integrations = [],
    additionalMetrics = {},
  } = data;

  const statusClassName = dealStatus ? getStatusClass(dealStatus) : "";
  const companyAvatar = company?.avatar || "/images/user-logo.svg";

  const handleCheckboxChange = (e) => {
    e.stopPropagation();
    if (onSelect) {
      onSelect(e.target.checked, false);
    }
  };

  const handleRowClick = (e) => {
    // Don't trigger navigation if clicking on dropdown, checkbox, button, or links
    if (
      e.target.closest('[role="menu"]') || 
      e.target.closest('.dropdown') || 
      e.target.closest('input[type="checkbox"]') ||
      e.target.closest('button') ||
      e.target.closest('a')
    ) {
      return;
    }

    // If in distributor view, navigate to overview page
    if (isDistributorView && onRowClick) {
      const mspAccountId = originalRowData?.id || originalRowData?.objId_Customer || rowIndex?.toString() || company?.name;
      onRowClick(mspAccountId);
      return;
    }

    // Handle shift+click for range selection
    if (e.shiftKey && onSelect) {
      onSelect(!isSelected, true);
      return;
    }

    // Regular click toggles selection when checkboxes are visible
    if (showCheckbox && onSelect && !e.target.closest('input[type="checkbox"]')) {
      onSelect(!isSelected, false);
    } else if (onSelect && !showCheckbox) {
      // If checkboxes aren't visible yet, clicking should select and show them
      onSelect(!isSelected, false);
    }
  };

  let gridTemplate = isDistributor 
    ? "205px 160px 234px 244px 160px 160px 140px 146px 121px 167px 96px 88px 88px 88px 88px 213px 96px 96px 88px 40px"
    : "205px 160px 163px 234px 244px 160px 160px 140px 146px 121px 167px 96px 88px 88px 88px 88px 213px 96px 96px 88px 40px";
  
  if (showCheckbox) {
    gridTemplate = `40px ${gridTemplate}`;
  }

  return (
    <div className={styles.v2Row} role="row" onClick={handleRowClick} style={{ cursor: isDistributorView ? 'pointer' : 'default', gridTemplateColumns: gridTemplate }}>
      {showCheckbox && (
        <div className={styles.v2CheckboxCell} role="cell">
          <div className={styles.checkboxContainer}>
            <Form.Group className={styles.checkboxGroup}>
              <Form.Check
                type="checkbox"
                checked={isSelected}
                onChange={handleCheckboxChange}
                onClick={(e) => e.stopPropagation()}
                className={styles.checkbox}
              />
            </Form.Group>
          </div>
        </div>
      )}
      <div className={`${styles.companyCell} ${styles.v2FirstCol}`} role="cell" style={showCheckbox ? { left: 'calc(40px + 0.5rem)' } : undefined}>
        <div
          className={styles.companyAvatar}
          style={{ backgroundImage: `url(${companyAvatar})` }}
          aria-label={`${company?.name ?? "Company"} avatar`}
        />
        <div className={styles.companyName}>{company?.name}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{location}</div>
          </div>

      {!isDistributor && (
        <div className={styles.v2Cell} role="cell">
          <DistributorDropdown value={distributor} />
        </div>
      )}

      <div className={styles.v2Cell} role="cell">
        <div className={`${styles.contactAvatar} ${getContactAvatarClass(primaryContact?.bgColor)}`}>
          <span className={styles.contactInitial}>{primaryContact?.initial}</span>
        </div>
        <div className={styles.v2CellColumn}>
          <div className={styles.textPrimary}>{primaryContact?.name}</div>
          <div className={styles.textSecondary}>{primaryContact?.email}</div>
        </div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={`${styles.contactAvatar} ${getContactAvatarClass(secondaryContact?.bgColor)}`}>
          <span className={styles.contactInitial}>{secondaryContact?.initial}</span>
        </div>
        <div className={styles.v2CellColumn}>
          <div className={styles.textPrimary}>{secondaryContact?.name}</div>
          <div className={styles.textSecondary}>{secondaryContact?.email}</div>
        </div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{createdDate}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{lastActivity}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.subscriptionPill}>{subscription?.status}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{renewalDate}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{autoRenewal}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <TagsDropdown tags={tags} />
      </div>

      <div className={styles.v2Cell} role="cell">
        {dealStatus ? (
          <div className={`${styles.statusBadge} ${statusClassName}`}>
            <span className={styles.statusDot} aria-hidden />
            <span>{dealStatus.label}</span>
          </div>
        ) : (
          <div className={styles.textSecondary}>--</div>
        )}
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{metrics.members ?? "--"}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{metrics.companies ?? "--"}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{metrics.clients ?? "--"}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{metrics.prospects ?? "--"}</div>
      </div>

      <div className={`${styles.v2Cell} ${styles.v2CellColumn}`} role="cell">
        <div className={styles.integrationList}>
          {integrations.map((integration, index) => {
            const integrationIcon = integration.icon || "/images/user-logo.svg";
            return (
              <div key={`${integration.name}-${index}`} className={styles.integrationItem}>
                <div
                  className={styles.integrationIcon}
                  style={{ backgroundImage: `url(${integrationIcon})` }}
              aria-label={`${integration.name} logo`}
            />
                <div className={styles.textPrimary}>{integration.name}</div>
            </div>
            );
          })}
        </div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{additionalMetrics.products ?? "--"}</div>
        </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{additionalMetrics.services ?? "--"}</div>
      </div>

      <div className={styles.v2Cell} role="cell">
        <div className={styles.textPrimary}>{additionalMetrics.packages ?? "--"}</div>
      </div>

      <div className={`${styles.v2Cell} ${styles.actionCell}`} role="cell">
        <ActionsDropdown isArchived={false} companyName={company?.name} />
      </div>
    </div>
  );
};

const ActionsDropdown = ({ isArchived, companyName }) => (
  <Dropdown align="end">
    <Dropdown.Toggle className={rowStyles.dropdownToggle} variant="link">
      <img className={rowStyles.moreButtonImg} alt="" src="/images/horizontal-dots.svg" />
    </Dropdown.Toggle>
    <Dropdown.Menu className={rowStyles.dropdownMenuWrapper}>
      <RowDropdown isArchived={isArchived} companyName={companyName} />
    </Dropdown.Menu>
  </Dropdown>
);